import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="w-full pt-14 pb-20 px-5 sm:px-8 lg:px-12 flex flex-col items-center text-center bg-[#CFE9F7]" data-id="element-25">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-26">
        {/* Eyebrow */}
        <p className="text-gold tracking-[0.2em] text-xs md:text-sm font-semibold uppercase mb-6" data-id="element-27">
          Adulto Saludable · super pack Adultos Mayores
        </p>

        {/* Headline */}
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-[#0F1535]" data-id="element-28">
          Ayudá a tu ser querido a mantener su autonomía, su mente activa y su
          bienestar desde casa.—
        </h1>

        {/* Subheadline */}
        <h2 className="text-xl md:text-2xl font-medium text-[#FF811B] mb-[25px]" data-id="element-29">
          El sistema más completo para cuidar al adulto mayor con seguridad,
          organización y confianza.
        </h2>
        <p className="mb-12 text-[#FF811B] font-[500] text-[16px]" data-id="element-30">
          🧠 Estimulación Cognitiva. 🚶 Movilidad. ❤️ Bienestar. 📋
          Organización. 👨‍👩‍👧 Guía para cuidadores. 📖 Más de 500 páginas listas
          para imprimir.
        </p>

        {/* Product Image */}
        <div className="relative w-full max-w-2xl mb-8" data-id="element-31">
          <img src="https://cdn.magicpatterns.com/uploads/9jvmQLcAG4vA2KduuCpCFG/Diseno_sin_titulo_(14).png" alt="Profesional de la salud sosteniendo el sistema Vitalidad 360" className="w-full h-auto rounded-xl shadow-2xl object-cover object-top max-h-[500px]" data-id="element-32" />
          {/* Mockup Overlay (Simulated) */}
          <div className="absolute inset-0 flex items-center justify-center rounded-xl" data-id="element-33"></div>
        </div>

        {/* Description below image */}
        <p className="text-sm md:text-base max-w-2xl text-[#0F1535] mb-[5px]" data-id="element-34">
          ✔ 5 Modulos de Estimulación Cognitiva + Módulo PREMIUM EJERCICIOS EN
          CASA
        </p>
        <p className="text-sm md:text-base max-w-2xl text-[#0F1535] mb-[5px]" data-id="element-35">
          ✔ 4 Modulos de Estimulación Física
        </p>
        <p className="text-sm md:text-base max-w-2xl text-[#0F1535] mb-[5px]" data-id="element-36">
          ✔ Programa Premium de 90 días
        </p>
        <p className="text-sm md:text-base max-w-2xl text-[#0F1535] mb-[5px]" data-id="element-37">
          ✔ Más de 500 páginas imprimibles
        </p>
        <p className="text-sm md:text-base max-w-2xl text-[#0F1535] mb-[32px]" data-id="element-38">
          ✔ Acceso inmediato
        </p>

        {/* Badge */}
        <div className="inline-flex items-center justify-center bg-navy-deep border border-white/10 rounded-full py-2 px-4 md:px-6 mb-8 text-xs md:text-sm text-gray-200" data-id="element-39">
          Super Pack Imprimible y de Acceso Inmediato (No pagás envío, lo
          recibís en tu email al instante)
        </div>

        {/* CTA */}
        <CTAButton className="mb-6 w-full md:w-auto" data-id="element-40" />

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-4 text-xs text-gray-400" data-id="element-41">
          <div className="flex items-center text-[#0F1535]" data-id="element-42">
            <span className="mr-1" data-id="element-43">🛡️</span> Garantía de satisfacción de 7 días
          </div>
          <div className="flex items-center text-[#0F1535]" data-id="element-44">
            <span className="mr-1" data-id="element-45">🔒</span> Pago 100% seguro
          </div>
          <div className="flex items-center text-[#0F1535]" data-id="element-46">
            <span className="mr-1" data-id="element-47">💳</span> Tarjeta · Mercado Pago · Ualá ·
            Transferencia
          </div>
        </div>
      </div>
    </section>;
}